import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import Checkbox from '../../CoreWrappers/Checkbox';
import StyledCheckboxGroup from './StyledCheckboxGroup';

import Tooltip from '../../CoreWrappers/Tooltip';

const CheckboxGroup = ({value, onChange, groupDisabled}) => {
	const handleChange = (id) => {
		const newValue = value.map((item) => {
			if (item.id === id) {
				if (item.indeterminate) return {...item, checked: item.checked, indeterminate: false};
				return {...item, checked: !item.checked};
			}
			return {...item};
		});
		onChange(newValue);
	};

	return (
		<StyledCheckboxGroup>
			{value.map(({id, label, checked = false, disabled = false, indeterminate = false, tooltip}, index) => {
				const renderCheckbox = (index = null) => {
					const props = {
						id: `checkbox-group-${id}`,
						disabled: !!disabled || groupDisabled,
						checked: !!checked,
						indeterminate: !!indeterminate,
						value: !!checked,
						label,
						// title: tooltip,
						// labelTitletip: tooltip,
						hidetitletip: true,
						onChange: () => handleChange(id)
					};

					const wrpProps = {};

					if (index) wrpProps.key = index;

					return <Checkbox {...props} />;
				};

				if (!!tooltip) {
					const props = {
						trigger: renderCheckbox(),
						tooltipText: tooltip,
						placement: 'top'
					};

					<div title={tooltip}>{renderCheckbox()}</div>;
					// return <Tooltip {...props} />; 
					// TODO: https://github.com/ey-org/Motif-React/issues/1608 open motif issue for tooltips inside dropdowns
				}

				return renderCheckbox(index);
			})}
		</StyledCheckboxGroup>
	);
};

const checkboxShape = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	label: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string
};

CheckboxGroup.propTypes = {
	value: PropTypes.arrayOf(PropTypes.shape(checkboxShape)).isRequired
};

CheckboxGroup.defaultProps = {};

export default CheckboxGroup;
